import React from 'react';
import CurrencyFormat from 'react-currency-format';
import tw from 'twin.macro';

import { Button, OtpInput } from '@/components';

import { BodyText } from '../components';
import Timer from '../components/ui/timer/timer';

const OtpVerify = ({
  phone,
  isValid,
  loading,
  handleSubmit,
  handleVerify,
  control,
  initialMinutes = 0,
  initialSeconds = 59,
  showChangePhone = true,
  changeNumber = () => {},
  resendOtp = () => {},
  timerVariant = 'otp-verify',
  otpLabel = 'Введите код из SMS',
  showButton = true,
  numInputs
}) => {
  return (
    <form onSubmit={handleSubmit(handleVerify)}>
      <div tw='bg-secondary p-5 pt-[8px] sm:rounded-2xl'>
        {phone && (
          <div>
            <div tw='mt-3 mb-1 flex flex-col gap-1 items-center'>
              <BodyText text='Код отправлен на номер' twStyle={tw`text-secondary`} />
              <CurrencyFormat
                value={phone}
                displayType={'text'}
                format='+##################'
                tw='font-bold text-s14 text-secondary'
              />
            </div>
          </div>
        )}
        <div>
          <OtpInput
            label={otpLabel}
            control={control}
            shouldAutoFocus={true}
            name='code'
            numInputs={numInputs}
            rules={{ required: { value: true, message: 'Это поле не может быть пустым' } }}
          />
        </div>
      </div>
      {showButton && (
        <div tw='w-full my-5 sm:p-0 text-center'>
          <Button variant='secondary' type='submit' disabled={!isValid} loading={loading}>
            Далее
          </Button>
          <Timer
            initialMinutes={initialMinutes}
            initialSeconds={initialSeconds}
            resendOtp={resendOtp}
            variant={timerVariant}
          />
          {showChangePhone && (
            <div tw='py-3'>
              <Button variant='link' onClick={changeNumber}>
                Изменить номер
              </Button>
              {/*<SubTitle text='Изменить номер' variant='bold' twStyle={tw`text-green text-s14 cursor-pointer`} />*/}
            </div>
          )}
        </div>
      )}
    </form>
  );
};
export default OtpVerify;
